import { handleRest } from '../../h2Api'
import { LOAD_APPROVAL_PROFILE } from '../../actions/profileApproval'

const initialRequestState = handleRest()
const reducers = (state = initialRequestState, action) => {
  switch (action.type) {
    case LOAD_APPROVAL_PROFILE:
      return {
        ...state,
        ...handleRest(action)
      }
    default:
      return state
  }
}

export default reducers
